<template>
    <div>
        <dx-grid
            url="covidScreeningSessions"
            :columns="columns"
            :title="title"
            :expandedOptions="{
                enabled: true,
                template: 'covid-screening-sms-messages',
            }"
        ></dx-grid>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "SMS Sessions",
        columns: [
            {
                field: "status",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value) => {
                    switch (value) {
                        case "Completed":
                            return "mdi-check-circle";
                        case "Aborted":
                            return "mdi-close-circle";
                        case "InProgress":
                            return "mdi-clock";
                        case "Error":
                            return "mdi-alert-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "Completed":
                            return "success";
                        case "Aborted":
                            return "#aeb8bf";
                        case "Error":
                            return "#f35123";
                        default:
                            return "#fdb400";
                    }
                },
            },
            {
                field: "accountID",
                label: "Account ID",
                //link: "AccountView",
                format: "",
                //template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(moment().subtract(1, "days")),
                selectedFilterOperation: ">",
                visible: true,
            },
            {
                label: "Caller ID",
                field: "callerID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cellphone",
                field: "cellPhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "questionsStarted",
                label: "Questions Started",
                format: "",
                visible: false,
                filterType: "",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {},
    methods: {},
};
</script>
<style></style>
